import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogIn, Loader2, Lock } from "lucide-react";

const DEFAULT_LOGO = "https://customer-assets-wrfwihn1.emergentagent.net/job_agent-hub-375/artifacts/ijuy74i5_LOGO%20DOPOPAY.webp";

export default function AdminLogin() {
  const { user, loading, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate("/admin/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError("");
    setSubmitting(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      setUser(res.data);
      navigate("/admin/dashboard", { replace: true, state: { user: res.data } });
    } catch (err) {
      setError(err?.response?.data?.detail || "Accesso non riuscito");
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111111] text-white flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#FFCC00]/10 rounded-full blur-3xl" />
      <form onSubmit={submit} className="relative w-full max-w-md bg-white/5 border border-white/10 rounded-3xl p-8 md:p-10 backdrop-blur-xl">
        <img src={DEFAULT_LOGO} alt="Dopopay" className="h-8 mx-auto mb-8" />
        <div className="text-center mb-8">
          <h1 className="font-display text-2xl font-bold flex items-center justify-center gap-2"><Lock className="w-5 h-5 text-[#FFCC00]" /> Area riservata</h1>
          <p className="text-white/60 mt-2 text-sm">Accesso riservato agli amministratori Dopopay</p>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="mb-1.5 block text-white/80">Email</Label>
            <Input data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="admin.dopopay.it" autoComplete="username"
              className="h-12 rounded-xl bg-white/5 border-white/15 text-white placeholder:text-white/30 focus-visible:ring-[#FFCC00]" />
          </div>
          <div>
            <Label className="mb-1.5 block text-white/80">Password</Label>
            <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" autoComplete="current-password"
              className="h-12 rounded-xl bg-white/5 border-white/15 text-white placeholder:text-white/30 focus-visible:ring-[#FFCC00]" />
          </div>
        </div>

        {error && <p data-testid="login-error" className="text-sm text-red-400 mt-4 text-center">{error}</p>}

        <Button type="submit" data-testid="login-submit-btn" disabled={submitting}
          className="mt-8 w-full h-12 rounded-xl bg-[#FFCC00] hover:bg-[#E6B800] text-black font-semibold transition-transform duration-200 hover:-translate-y-0.5">
          {submitting ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Accesso…</> : <><LogIn className="w-4 h-4 mr-2" /> Accedi</>}
        </Button>

        <a href="/" className="block mt-6 text-sm text-white/50 hover:text-white transition-colors text-center">← Torna al sito</a>
      </form>
    </div>
  );
}
